import { Card } from '@foodsby/nutrient'
import React from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import { Article } from '../components/common/Layout'
import UnsubscribeForm from '../components/unsubscribe/UnsubscribeForm'
import { triggerUnsubscribe } from '../redux/modules/unsubscribe'

const UnsubscribeFormContainer = reduxForm({ form: 'unsubscribe' })(UnsubscribeForm)

export const PageUnsubscribe = props => {
  const { error, submitting, success } = props
  const { triggerUnsubscribe } = props
  return (
    <Article>
      <Card>
        <div className="panel">
          <div className="row center-xs">
            <div className="col-xs">
              <p className="primary panel-title">Are you sure you want to stop receiving emails?</p>
              <UnsubscribeFormContainer onSubmit={triggerUnsubscribe} submitting={submitting} />

              {success && (
                <div className="success">
                  <p>{'You have successfully been unsubscribed.'}</p>
                </div>
              )}

              {error !== undefined && (
                <div className="error">
                  <p>{error}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </Card>
    </Article>
  )
}

const mapStateToProps = state => {
  const { error, submitting, success } = state.unsubscribe
  return { error, submitting, success }
}

const mapDispatchToProps = {
  triggerUnsubscribe,
}

export default connect(mapStateToProps, mapDispatchToProps)(PageUnsubscribe)
